import requests from './requests';

export default {
    getRandomSplash() {
        return requests
            .get('/asset/splash/rand')
            .then(resp => resp.data);
    },
    getRandomAvatar() {
        return requests
            .get('/asset/avatar/rand')
            .then(resp => resp.data);
    },
};



// WEBPACK FOOTER //
// ./src/api/asset.js